var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLovely(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.86 8.09009C19.86 8.24009 19.86 8.39009 19.85 8.53009C18.32 7.96009 16.52 8.31009 15.32 9.39009C14.51 8.66009 13.46 8.25009 12.34 8.25009C9.88 8.25009 7.88 10.2601 7.88 12.7401C7.88 15.5701 9.3 17.6401 10.66 18.9801C10.55 18.9701 10.46 18.9501 10.38 18.9201C7.79 18.0301 2 14.3501 2 8.09009C2 5.33009 4.21999 3.1001 6.95999 3.1001C8.58999 3.1001 10.03 3.88009 10.93 5.09009C11.84 3.88009 13.28 3.1001 14.9 3.1001C17.64 3.1001 19.86 5.33009 19.86 8.09009Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 9.59009C16.9299 9.59009 15.9599 10.1101 15.3599 10.9101C14.7599 10.1101 13.7999 9.59009 12.7199 9.59009C10.8999 9.59009 9.41992 11.0701 9.41992 12.9101C9.41992 13.6201 9.52992 14.2701 9.72992 14.8701C10.6699 17.8401 13.5599 19.6101 14.9899 20.1001C15.1899 20.1701 15.5199 20.1701 15.7299 20.1001C17.1599 19.6101 20.0499 17.8401 20.9899 14.8701C21.1899 14.2601 21.2999 13.6101 21.2999 12.9101C21.2999 11.0701 19.8199 9.59009 17.9999 9.59009Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovely);
export default __webpack_public_path__ + "static/media/lovely.d3464f91dba18155f57710d0826c5529.svg";
export { ForwardRef as ReactComponent };